
define('text!TescoMobile_Checkout/template/monthly-payment-modal-info.html',[],function () { return '<div id="tm-kba-info-content"><p class="message"><%= data.content_modal %></p></div>';});

